import { useClickOutside } from '@carboncopyco/utils';
import { useState } from 'react';

type TdInputProps = {
  initialValue: string;
  isDisabled: boolean;
  onSubmit: (value: string) => void;
  onCancel: () => void;
};

export const TdInput = ({
  initialValue,
  isDisabled,
  onSubmit,
  onCancel,
}: TdInputProps) => {
  const [value, setValue] = useState(initialValue);
  const clickAwayDropdownRef = useClickOutside(() => {
    if (value === initialValue) {
      onCancel();
      return;
    }
    onSubmit(value);
  }, [value]);

  return (
    <div
      ref={clickAwayDropdownRef}
      className="absolute inset-0 border border-solid border-ds-primary bg-white"
    >
      <input
        className="absolute inset-0 px-[7px] bg-ds-natural-100 text-ds-200 outline-none p-0 bg-transparent text-ds-natural-600 border-0 focus:border-0"
        style={{ boxShadow: 'none' }}
        type="text"
        onKeyDown={(e) => {
          if (e.key === 'Enter' && value !== initialValue) {
            onSubmit(value);
          }
        }}
        autoFocus
        name="name"
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        disabled={isDisabled}
      />
    </div>
  );
};
